import React from 'react'
import Header from './Header'
import Footer from './Footer'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import * as Yup from 'yup'

export default function Contact() {
    const initialValues = {
        firstName: '',
        lastName: '',
        email: '',
        companyName: '',
        companySize: '',
        topic: '',
        message: '',
    }

    const validationSchema = Yup.object().shape({
        firstName: Yup.string().required('Required'),
        lastName: Yup.string().required('Required'),
        email: Yup.string()
            .email('Enter a valid email address')
            .required('Email is required'), companyName: Yup.string().required('Required'),
        companySize: Yup.string().required('Required'),
    })

    const handleSubmit = (values, actions) => {
        console.log('Form values:', values)
        actions.setSubmitting(false)
        actions.resetForm()
        alert('Form submitted successfully!')
    }

    return (
        <>
            <Header />
            <div className="contactContainer lg:my-5 p-5">
                <div className="row align-items-center">
                    {/* Left Column - Image and Text */}
                    <div className="col-lg-6 mb-4">
                        <h2 className="mb-3 lg:mx-5 font-bold">Need support?</h2>
                        <p className="text-muted lg:mx-5">Fill in the form to get in touch</p>
                        {/* <img
                            src="https://img.freepik.com/free-vector/flat-design-illustration-customer-support_23-2148887720.jpg?t=st=1755501865~exp=1755505465~hmac=4df8b1fafe5233ceb2f1b60dc331bab2ca6a4b6cd8ef91ce25b36a7095ceeb75&w=1480"
                            alt="support"
                            className="img-fluid rounded"
                        /> */}
                        <img src='../../images/ContactUs.png' style={{ width: '40rem', height: '34rem' }} className='d-none d-sm-block' />

                    </div>

                    {/* Right Column - Form */}
                    <div className="col-lg-6">
                        <Formik
                            initialValues={initialValues}
                            validationSchema={validationSchema}
                            onSubmit={handleSubmit}
                        >
                            {({ isSubmitting }) => (
                                <Form>
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <label className="form-label">First Name</label>
                                            <Field name="firstName" className="form-control custom-input" placeholder="First Name" />
                                            <ErrorMessage name="firstName" component="div" className="text-danger" />
                                        </div>

                                        <div className="col-md-6">
                                            <label className="form-label">Last Name</label>
                                            <Field name="lastName" className="form-control custom-input" placeholder="Last Name" />
                                            <ErrorMessage name="lastName" component="div" className="text-danger" />
                                        </div>

                                        <div className="col-12">
                                            <label className="form-label">Email</label>
                                            <Field name="email" type="email" className="form-control custom-input" placeholder="Enter your email" />
                                            <ErrorMessage name="email" component="div" className="text-danger" />
                                        </div>

                                        <div className="col-12">
                                            <label className="form-label">Company Name</label>
                                            <Field name="companyName" className="form-control custom-input" />
                                            <ErrorMessage name="companyName" component="div" className="text-danger" />
                                        </div>

                                        <div className="col-12">
                                            <label className="form-label">Company Size</label>
                                            <Field as="select" name="companySize" className="form-select custom-input">
                                                <option value="">Please select</option>
                                                <option value="1-10">1-10</option>
                                                <option value="11-50">11-50</option>
                                                <option value="51-200">51-200</option>
                                                <option value="200+">200+</option>
                                            </Field>
                                            <ErrorMessage name="companySize" component="div" className="text-danger" />
                                        </div>

                                        <div className="col-12">
                                            <label className="form-label">Which topic best fits your needs?</label>
                                            <Field as="select" name="topic" className="form-select custom-input">
                                                <option value="">Please select</option>
                                                <option value="support">Support</option>
                                                <option value="sales">Sales</option>
                                                <option value="general">General</option>
                                            </Field>
                                        </div>

                                        <div className="col-12">
                                            <label className="form-label">How can we help?</label>
                                            <Field as="textarea" name="message" className="form-control custom-input" rows="4" />
                                        </div>
                                        <div className="row">
                                            <button
                                                type="submit"
                                                className="contactButton mt-3 mx-2"
                                                disabled={isSubmitting}
                                            >
                                                {isSubmitting ? 'Submitting...' : 'Submit'}
                                            </button>
                                        </div>
                                    </div>

                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>

                <div className="row p-3 mt-3 card-body" style={{ backgroundColor: '#f5f7fa', borderRadius: '10px' }}>
                    <div className="col-lg-4 d-flex justify-content-start bg-white rounded-start p-4 flex-col">
                        <h3 className="fw-bold fs-2 mb-3">Contact us</h3>
                        <address className="mb-0 text-gray-500" style={{  lineHeight: '1.6' }}>
                            L-30 Tez Kumar Plaza,<br />
                            Trilokinath Marg, Sushapura,<br />
                            Hazratganj, Lucknow,<br />
                            Uttar Pradesh 226001<br />
                            India
                        </address>
                    </div>

                    <div className="col-lg-8 p-0">
                        {/* <img
                            src="https://as2.ftcdn.net/v2/jpg/02/65/42/55/1000_F_265425516_wtAw64cGdOVvrdl64b5bsyBqcD0rkw1W.jpg"
                            alt="map"
                        /> */}
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3559.787762937267!2d80.94167387522191!3d26.84670197668658!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399bfd003aff7c49%3A0x9b5c3242a09b6724!2sTez%20Kumar%20Plaza!5e0!3m2!1sen!2sin!4v1755666246505!5m2!1sen!2sin"
                            width="900"
                            height="450"
                            style={{ border: 0 }}
                            allowFullScreen
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        ></iframe>
                    </div>
                </div>

            </div>
            <Footer />
        </>
    )
}
